export const evolucional_redirect_url = 'https://simulados.evolucional.com.br/sair';
export const defaultModalSize = '80%';
export const defaultModalHeight = '60vh';
export const error500Message = 'A plataforma pode estar passando por uma instabilidade momentânea. Por favor, tente novamente em alguns instantes.'

export const DEFAULT_PER_PAGE = 10;
export const DEFAULT_PER_PAGE_DATA_TABLE = -1;
export const DEFAULT_PER_PAGE_DATA_TABLE_OPTIONS = [ 10, 20, 50, 100, -1];

export const DEFAULT_SORTABLE_ICON = 'fas fa-sort-up'

export const DEFAULT_DIALOG_WIDTH = "80vw"

export const DEFAULT_MODAL_OVERLAY_COLOR = '#000000';

export const TYPE_MODULE = 'module';

export const DEFAULT_DIALOG_SCROLL_HEIGHT = "75vh"

export const DEVELOP_DOMAINS = ['localhost','aura.pc4.com.br','nitro.test','nitro-listas.pc4.com.br','nitro-demo.pc4.com.br']

export const DEFAULT_DATETIME_FORMAT = "DD/MM/yyyy HH:mm"

/** Common table cell widths */
export const DEFAULT_MODULE_NAME_TABLE_CELL_WIDTH = 300;
export const DEFAULT_SUBJECT_NAME_TABLE_CELL_WIDTH = 220;
export const DEFAULT_USER_NAME_TABLE_CELL_WIDTH = 300;
export const DEFAULT_USER_IDENTIFIER_TABLE_CELL_WIDTH = 100;

export const FULL_HD_HEIGHT = 1080;
export const HD_HEIGHT = 700;

export const isInDevelop = (function name() {
  return DEVELOP_DOMAINS.includes(window.location.host)
})()

export const isNotInDevelop = (function name() {
  return !DEVELOP_DOMAINS.includes(window.location.host)
})()

import moment from "moment"

export const VACATION_PERIODS = [
  ["2022-07-02","2022-08-07"]
]

export const  IS_ON_VACATION =  (() => VACATION_PERIODS.map((dates) => moment().isBetween(dates[0], dates[1]) ? 1 : 0 ).reduce((a,b) => a + b))();

export const DEFAULT_MODAL_OPACITY = '0.9';

